import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  disabledField: {
    background: "#ececec",
  },
  form: {
    textAlign: "left",
    marginBottom: "1.5rem",
  },
  greenCheck: {
    height: "20px",
    width: "20px",
    color: "#16871c",
  },
  helpText: {
    fontSize: "0.75rem",
    color: theme.palette.events.bluePrimary,
  },
  infoText: {
    fontSize: "0.875rem",
    marginTop: "10px",
  },
  textFieldInput: {
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: 0,
    marginTop: 0,
  },
  textField: {
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: "4px",
    marginTop: 0,
    boxShadow: "4px 4px 4px 0px #0C38911A",
  },
  buttonContent: {
    textTransform: "none",
  },
}));
